export { default as App } from 'pages/App';
export { default as Dashboard } from 'pages/Dashboard';
export { default as LoginOrRegister } from 'pages/LoginOrRegister';
export { default as About } from 'pages/About';
export {default as Administrator } from 'pages/Administrator';
export {default as Templates} from 'pages/Templates'; 
export {default as Autopilot} from 'pages/Autopilot'; 
export {default as Delivery} from 'pages/Delivery'; 
export {default as DeveloperTools} from 'pages/DeveloperTools'; 
export {default as Billing} from 'pages/Billing';
export {default as Bookkeeping} from 'pages/Bookkeeping'; 
export {default as Print} from 'pages/Print'; 
export {default as PrintPOS} from 'pages/PrintPOS'; 
export {default as Labels} from 'pages/Labels';
export {default as Drafts} from 'pages/Drafts';
export {default as DraftEdit} from 'pages/DraftEdit';




// WEBPACK FOOTER //
// app/pages/index.js